import ZoomInOut from '../ZoomInOut';
import TextView from '../TextView';

const ArchiveOCR = ({ API_URL, imageName, editedText, isEditing, setEditedText, folderDir, searchText }) => {


    return (
        <>
            <div className='container flex flex-wrap mt-2 border-t-2 border-blue-100'></div>
            <div className='flex'>
                <h1 className="text-3xl text-center h-10 rounded-full text-slate-800 bg-blue-300 font-bold border border-blue-500 -ml-5 w-10 border-t-0">3</h1>
                <span className='text-4xl ml-2 font-bold text-slate-800'>Image to Text</span>
            </div>
            <div className="grid grid-cols-2 space-x-4 ml-8 -mt-7">

                <div className="">
                    <ZoomInOut API_URL={API_URL} folderDir={folderDir} selectedImage={imageName} />
                </div>

                <div className='-mt-3'>
                    <div className="container text-right">
                        <TextView editedText={editedText} isEditing={isEditing} setEditedText={setEditedText} searchText={searchText} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ArchiveOCR;
